import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: true,
  prefix: '<hr style="margin:5px"/>',
  createroutes: true,
  name: 'club',
  meta: {
    label: 'CLUB',
    permission: '',
    icon: 'mdi-drag-variant',
    expanded: false
  },
  children: [
    {
      name: 'club_matches',
      path: '/club/:club_id/matches/',
      props: true,
      meta: {
        label: 'Wedstrijden',
        icon: 'mdi-security',
        permission: 'COMAV'
      },
      component: lazyLoading('province/Matches')
    },
    {
      name: 'club_teams',
      path: '/club/:club_id/teams/',
      props: true,
      meta: {
        label: 'Ploegen',
        icon: 'mdi-security',
        permission: 'COTEV'
      },
      component: lazyLoading('admin/security/Rules')
    }
  ]
  /* ,
  {
    name: 'Leden',
    path: '/admin/members',
    meta: {
      permission: '*',
      link: 'admin/Members.vue'
    },
    component: lazyLoading('admin/Members')
  } */
}



// WEBPACK FOOTER //
// ./src/store/menu/club.js